import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AccountMenu, AccountMenuSpacing, ButtonSize, Popover, PopoverSize, usePopoverHandlers, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { CaretRightIcon, XIcon } from '@yonderland/andes-icons';
import { Box, Breakpoint, Icon, IconButton, Link, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useOAuth } from '../../hooks/useOAuth';
const AccountMenuProfileContainer = ({ items, hideOnMobile, title }) => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const accountMenuTranslations = {
        logout: t(`${I18N_NAMESPACES.account}:account.logout`),
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const { logout, isLoggedIn, loginState } = useOAuth();
    const { isInAuthorMode } = useAemConfig();
    const handleLogout = () => logout();
    const [shouldRender, setShouldRender] = useState(isInAuthorMode);
    const mappedItems = items
        .filter(item => !item.hideForGuest || isLoggedIn)
        .map(item => ({
        href: item.link,
        label: item.label,
        isActive: item.active,
    }));
    const activeItemLabel = (_a = mappedItems.find(item => item.isActive)) === null || _a === void 0 ? void 0 : _a.label;
    useEffect(() => {
        if (!shouldRender && loginState !== 'PENDING') {
            setShouldRender(true);
        }
    }, [loginState]);
    if (!shouldRender)
        return null;
    return (_jsxs(_Fragment, { children: [_jsxs(Breakpoint, { from: "lg", children: [title.show && (_jsx(Box, { paddingBlockEnd: "3", children: _jsx(TextAlpha, { as: "h3", variant: "subheadingS", children: title.value || t('account.account.popover') }) })), _jsx(AccountMenu, { spacing: AccountMenuSpacing.SMALL, buttonSize: ButtonSize.SMALL, items: mappedItems, onLogout: isLoggedIn ? handleLogout : undefined, noMarginRight: true, translations: accountMenuTranslations })] }), _jsxs(Breakpoint, { until: "lg", children: [!hideOnMobile && (_jsx(Box, { paddingBlockEnd: "6", marginInline: { base: '-4', md: '0' }, children: _jsxs(Link, { variant: "secondary", onClick: handlePopoverOpen, size: "sm", children: [_jsx(TextAlpha, { as: "h2", variant: "headingS", color: "emphasised", children: activeItemLabel }), _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }) })), _jsx(Popover, { anchorEl: anchorEl, onClose: handlePopoverClose, title: title.show ? title.value || t('account.account.popover') : null, rightElement: _jsx(IconButton, { onClick: handlePopoverClose, variant: "plain", icon: { source: XIcon }, size: "sm" }), size: PopoverSize.MEDIUM, children: _jsx(AccountMenu, { items: mappedItems, onLogout: isLoggedIn ? handleLogout : undefined, translations: accountMenuTranslations }) })] })] }));
};
export default AccountMenuProfileContainer;
